export default "__VITE_ASSET__6abe41a1__"